const toggle = document.getElementById('card-toggle');
const content = document.getElementById('card-content');
const backgrounds = document.getElementById('hero-default-backgrounds');

if (toggle && content) {
    [...toggle.children].forEach((item) => {
        item.addEventListener('click', () => {
            [...toggle.children].forEach((item) => item.classList.remove('active'));

            item.classList.toggle('active');
            const id = item.getAttribute('data-id');

            [...backgrounds.children].forEach((item) => {
                item.classList.remove('active');

                if (id === item.getAttribute('data-background-id')) {
                    item.classList.add('active');
                }
            });

            [...content.children].forEach((item) => {
                item.classList.remove('active');

                if (id === item.getAttribute('data-content-id')) {
                    item.classList.add('active');
                }
            })
        })
    })
}
